import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_close",
  "use": "icon-icon_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icon_close\"><g fill-rule=\"nonzero\" fill=\"none\"><circle fill=\"#F8F9FA\" cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"m9.172 7.757 2.827 2.827 2.83-2.827a1 1 0 0 1 1.414 1.415l-2.829 2.827 2.829 2.83a1 1 0 0 1-1.415 1.414L12 13.414l-2.827 2.829a1 1 0 1 1-1.415-1.415L10.584 12 7.757 9.172a1 1 0 0 1 1.415-1.415Z\" fill=\"#B6BABF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol